# Reference Links to Google Analytics classic tracker =>
#   https://developers.google.com/analytics/devguides/collection/gajs/

# GA Debugger for Chrome =>
#   https://chrome.google.com/webstore/detail/google-analytics-debugger/jnkmfdileelhofjcijamephohjechhna

NUMBER_REGEX = /(\d)+/
SEARCH_PARAMETERS = ["query", "author", "publication", "status"]

get_pathname = (url = null) ->
  return window.location.pathname unless url

  parser = document.createElement('a')
  parser.href = url
  return parser.pathname

get_path_parts = (pathname) ->
  return pathname.split('/')

get_portfolio_subdomain = (url = null, tld_length = 2) ->
  parser = document.createElement('a')
  parser.href = url || window.location
  domain_parts = parser.hostname.split('.')

  return if domain_parts.length > tld_length then domain_parts[0] else null

get_query_parts = (url = null) ->
  parser = document.createElement('a')
  parser.href = url || window.location
  params = (parser.search || "").substr(1).split("&")
  query_parts = _.select params, (param) ->
    (param.indexOf("=") > 0) && _.contains(SEARCH_PARAMETERS, param.split("=")[0])


class GoogleAnalyticsPage
  constructor: (url) ->
    @url = url
    @path_parts = get_path_parts(get_pathname(url))
    @portfolio_subdomain = get_portfolio_subdomain(url, GoogleAnalyticsTracker.TLD_LENGTH)
    @tracking_path_parts = []
    @last_path_part = null
    @custom_vars = [] # Array of pairs

    if @portfolio_subdomain
      @tracking_path_parts.push "[portfolio]"

    @_process_path_part part for part in @path_parts

    @query_parts = get_query_parts()

  original_url: ->
    @url

  tracking_url: ->
    result = "/" + @tracking_path_parts.join('/')
    if @query_parts.length > 0
      result = "#{result}?#{@query_parts.join('&')}"

    result

  custom_variables: ->
    @custom_vars

  _process_path_part: (part) ->
    if NUMBER_REGEX.test(part) then @_add_custom_var(part) else @_add_path_part(part)

  _add_custom_var: (value) ->
    name = "#{@last_path_part || 'unknown'}_id"
    @custom_vars.push [name, value]
    @tracking_path_parts.push "[#{name}]"

  _add_path_part: (part) ->
    if $.trim(part).length > 0
      @last_path_part = part
      @tracking_path_parts.push part


export default GoogleAnalyticsTracker =
  TLD_LENGTH: 2
  USER_SIGNED_IN: false

  pages: []

  initialize: (universal_tracking_id, cookie_domain) ->
    GoogleAnalyticsUniversalTracker.initialize(universal_tracking_id, cookie_domain)

  pageview: (url) ->
    url = $.trim(url)
    return console.log "Can't track an empty URL. Ignoring..." if $.trim(url).length == 0

    @pages.push @current_page if @current_page
    @current_page = new GoogleAnalyticsPage(url)

    GoogleAnalyticsUniversalTracker.pageview(@current_page)
    return

  page_event: (action, opt_label, opt_value) ->
    current_page = @get_current_page()
    GoogleAnalyticsUniversalTracker.page_event(current_page, action, opt_label, opt_value)
    return

  event: (category, action, opt_label, opt_value) ->
    GoogleAnalyticsUniversalTracker.event(category, action, opt_label, opt_value)
    return

  pop_current_page: ->
    @pages.pop()
    @current_page = _.last(@pages)

  get_current_page: ->
    @current_page = new GoogleAnalyticsPage(window.location) if !@current_page
    return @current_page


CUSTOM_DIMENSIONS =
  'publications_id'     : '1'
  'insights_id'         : '1' # segment insights by publication
  'stories_id'          : '2'
  'user_type'           : '3'
  'beta_request_email'  : '4'
  'portfolio'           : '5'
  'signed_in'           : '6'

get_custom_dimensions_from_page = (page) ->
  result = {}
  custom_vars = page.custom_variables()
  for i in [0...custom_vars.length]
    custom_var = custom_vars[i]
    dimension_name  = custom_var[0]
    dimension_value = custom_var[1]
    dimension_index = CUSTOM_DIMENSIONS[dimension_name]

    if dimension_index
      result["dimension#{dimension_index}"] = dimension_value

  if page.portfolio_subdomain
    dimension_index = CUSTOM_DIMENSIONS['portfolio']
    result["dimension#{dimension_index}"] = page.portfolio_subdomain

  result["dimension#{CUSTOM_DIMENSIONS['signed_in']}"] = GoogleAnalyticsTracker.USER_SIGNED_IN.toString()

  return result

get_event_fields = (category, action, opt_label, opt_value) ->
  fields =
    'hitType': 'event'
    'eventCategory': category
    'eventAction': action

  fields['eventLabel'] = opt_label if opt_label?
  fields['eventValue'] = opt_value if opt_value?

  return fields

GoogleAnalyticsUniversalTracker =
  initialize: (tracking_id, cookie_domain) ->
    ga('create', tracking_id, cookie_domain)

  pageview: (page) ->
    options = $.extend({ 'page': page.tracking_url() }, get_custom_dimensions_from_page(page))
    ga('send', 'pageview', options)

  page_event: (page, action, opt_label, opt_value) ->
    event_fields = get_event_fields(page.tracking_url(), action, opt_label, opt_value)
    ga('send', $.extend(event_fields, get_custom_dimensions_from_page(page)))

  event: (category, action, opt_label, opt_value) ->
    ga('send', get_event_fields(category, action, opt_label, opt_value))



// WEBPACK FOOTER //
// ./app/javascript/utils/shared/google_analytics_tracker.js.coffee